/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_N2Inputs */

const en_diff_ref_n2 = /** @type {(inputs: Diff_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The path exists only on the left. The value shown is the one that disappeared.`)
};

const ko_diff_ref_n2 = /** @type {(inputs: Diff_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경로가 왼쪽에만 있습니다. 표시된 값이 사라진 값입니다.`)
};

const ja_diff_ref_n2 = /** @type {(inputs: Diff_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスが左側にだけあります。表示されている値が消えた値です。`)
};

/**
* | output |
* | --- |
* | "The path exists only on the left. The value shown is the one that disappeared." |
*
* @param {Diff_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_n2 = /** @type {((inputs?: Diff_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_n2(inputs)
	if (locale === "ko") return ko_diff_ref_n2(inputs)
	return ja_diff_ref_n2(inputs)
});